class DocumentoAnexosUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlEnviar(idEntidadePai) {
		return `api/${this.PATH}/${idEntidadePai}/contratacao-publica/documento/lote`
	}

	getUrlExcluir(idDocumento) {
		return `api/${this.PATH}/contratacao-publica/documento/${idDocumento}`
	}
}

export default DocumentoAnexosUrlBuilder
